function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { CidMap, parseOrigin } from '@foody/common';
import { ICountry, IEnv } from '@shopee-mmc/endpoint-sdk';
import { CurrentCid } from '../MultisiteWrapper';
export var MmsPictureBizId;

(function (MmsPictureBizId) {
  // Driver
  MmsPictureBizId[MmsPictureBizId["DriverDelivery"] = 4502] = "DriverDelivery";
  MmsPictureBizId[MmsPictureBizId["DriverChat"] = 4503] = "DriverChat";
  MmsPictureBizId[MmsPictureBizId["DriverProfile"] = 4504] = "DriverProfile"; // Merchant

  MmsPictureBizId[MmsPictureBizId["MerchantItem"] = 4505] = "MerchantItem"; // Others

  MmsPictureBizId[MmsPictureBizId["Others"] = 4506] = "Others"; // Common

  MmsPictureBizId[MmsPictureBizId["Common"] = 4507] = "Common";
  MmsPictureBizId[MmsPictureBizId["DriverFaceVerification"] = 4518] = "DriverFaceVerification";
})(MmsPictureBizId || (MmsPictureBizId = {}));

export var MmsEnv = function () {
  var _parseOrigin = parseOrigin(),
      _parseOrigin$env = _parseOrigin.env,
      env = _parseOrigin$env === void 0 ? 'test' : _parseOrigin$env,
      isLive = _parseOrigin.isLive;

  if (isLive) {
    return IEnv.LIVE;
  }

  return {
    test: IEnv.TEST,
    uat: IEnv.UAT,
    staging: IEnv.STAGING
  }[env] || IEnv.TEST;
}();
export var MmsCid = function () {
  var _config;

  var config = (_config = {}, _defineProperty(_config, CidMap.id, ICountry.ID), _defineProperty(_config, CidMap.my, ICountry.MY), _defineProperty(_config, CidMap.th, ICountry.TH), _defineProperty(_config, CidMap.vn, ICountry.VN), _config);
  return config[CurrentCid] || ICountry.ID;
}();